var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" } },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("g", { attrs: { "fill-rule": "nonzero" } }, [
          _c("path", {
            attrs: {
              fill: "#95BF46",
              d: "M39.785 9.426a.462.462 0 0 0-.417-.388c-.174-.014-3.844-.286-3.844-.286s-2.55-2.53-2.829-2.811c-.28-.28-.827-.195-1.039-.132l-1.426.44c-.852-2.45-2.355-4.702-4.998-4.702-.073 0-.149.003-.224.007C24.256.56 23.325.128 22.521.128c-6.16 0-9.101 7.699-10.024 11.611l-4.31 1.337c-1.336.42-1.378.461-1.554 1.72-.132.953-3.627 27.982-3.627 27.982l27.235 5.103 14.757-3.192s-5.18-35.023-5.213-35.263zm-11.06-2.711l-2.305.713.002-.497c0-1.523-.212-2.749-.551-3.72 1.362.17 2.27 1.72 2.853 3.504zM24.18 3.512c.379.949.625 2.311.625 4.149 0 .094 0 .18-.002.267l-4.759 1.474c.917-3.537 2.634-5.246 4.136-5.89zm-1.83-1.732c.266 0 .534.09.79.267-1.973.928-4.09 3.268-4.983 7.939l-3.762 1.165c1.047-3.563 3.532-9.371 7.955-9.371z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#5E8E3E",
              d: "M39.368 9.038c-.174-.014-3.844-.286-3.844-.286s-2.55-2.53-2.829-2.811a.699.699 0 0 0-.393-.18l-2.06 42.12 14.756-3.192s-5.18-35.023-5.213-35.263a.462.462 0 0 0-.417-.388",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "#FFF",
              d: "M25.232 17.192l-1.82 5.413s-1.594-.851-3.548-.851c-2.865 0-3.01 1.798-3.01 2.25 0 2.473 6.444 3.42 6.444 9.21 0 4.556-2.889 7.489-6.785 7.489-4.675 0-7.066-2.91-7.066-2.91l1.252-4.135s2.458 2.11 4.531 2.11c1.355 0 1.906-1.067 1.906-1.847 0-3.225-5.286-3.368-5.286-8.667 0-4.46 3.2-8.775 9.662-8.775 2.49 0 3.72.713 3.72.713",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }